import React from 'react';
import {
  QuickAction,
  QuickActionsProvider,
  QuickActionsProviderContext,
} from './quick-actions-types';

// Clear search icon component
const ClearSearchIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

export class ClearSearchQuickActionsProvider implements QuickActionsProvider {
  id = 'clear-search-quick-actions-provider';
  name = 'Clear Search Quick Actions Provider';
  priority = 70; // Medium priority - appears after session actions but before screen sharing

  getActions(context: QuickActionsProviderContext): QuickAction[] {
    const actions: QuickAction[] = [];

    // Only show "Clear search" if onClearSearch function is available
    if (context.onClearSearch) {
      actions.push({
        id: 'clear-search',
        label: 'Clear search',
        icon: <ClearSearchIcon />,
        priority: 100,
        tooltip: 'Clear the search input',
        onClick: () => {
          context.onClearSearch?.();
        },
      });
    }

    return actions;
  }

  isActive(context: QuickActionsProviderContext): boolean {
    // Only active when onClearSearch function is available
    return !!context.onClearSearch;
  }
}
